import { FilterType, IHeadCell, OperatorFilterEnum, SelectFilterModelSimple } from 'features/common/types';
import { formatDateTimeToShowUserFromSaleOrderApiValue, formatDateToShowUser } from '../../../common/helpers';
import { IServiceListItem, serviceTypes } from '../../types';
import { countriesWithAgencyConfigToListFilter } from '../../../auth/constants';

export const serviceListHeaderCells: IHeadCell[] = [
	{ field: 'id', sortable: true, headerName: 'ID' },
	{ field: 'saleOrderId', sortable: true, headerName: 'ID de SaleOrder' },
	{ field: 'serviceType', sortable: true, headerName: 'Tipo' },
	{ field: 'reference', sortable: true, headerName: 'Referencia' },
	{ field: 'saleOrderDealId', sortable: true, headerName: 'Caso' },
	{ field: 'saleOrderIsBitrixDeal', sortable: true, headerName: 'Es Deal de Bitrix' },
	{ field: 'agencyId', sortable: true, headerName: 'Agencia' },
	{ field: 'tariffProviderFantasyName', sortable: true, headerName: 'Proveedor' },
	{ field: 'paymentDateToProvider', sortable: true, headerName: 'Pago proveedor' },
	{ field: 'totalCostMainCurrency', sortable: true, headerName: 'Costo' },
	{ field: 'totalSaleAmountMainCurrency', sortable: true, headerName: 'Venta' },
	{ field: 'minStartDate', sortable: true, headerName: 'Inicio' },
	{ field: 'maxEndDate', sortable: true, headerName: 'Fin' },
	{ field: 'enable', sortable: true, headerName: 'Activo' },
	{ field: 'voucherNotes', sortable: true, headerName: 'Notas voucher' },
	{ field: 'internalNotes', sortable: true, headerName: 'Notas internas' },
	{ field: 'created', sortable: true, headerName: 'Creado' },
	{ field: 'createdBy', sortable: true, headerName: 'Creado por' },
	{ field: 'updated', sortable: true, headerName: 'Actualizado' },
	{ field: 'updatedBy', sortable: true, headerName: 'Actualizado por' },
];

export const serviceListFilters = [
	{ label: 'Id de Servicio', type: FilterType.STRING, key: 'id', operator: OperatorFilterEnum.EQUALS },
	{ label: 'Id de SaleOrder', type: FilterType.STRING, key: 'saleOrderId', operator: OperatorFilterEnum.EQUALS },
	{ label: 'Caso o Deal', type: FilterType.NUMERIC, key: 'saleOrderDealId', operator: OperatorFilterEnum.EQUALS },
	{ label: 'Deal de Bitrix', type: FilterType.BOOLEAN, key: 'saleOrderIsBitrixDeal' },

	new SelectFilterModelSimple('Agencia', 'agencyId', countriesWithAgencyConfigToListFilter()),
	new SelectFilterModelSimple('Tipo', 'serviceType', serviceTypes),

	{ label: 'Referencia', type: FilterType.STRING, key: 'reference', operator: OperatorFilterEnum.CONTAINS },
	{
		label: 'Proveedor',
		type: FilterType.STRING,
		key: 'tariffProviderFantasyName',
		operator: OperatorFilterEnum.CONTAINS,
	},

	{ label: 'Pago proveedor', type: FilterType.DATE, key: 'paymentDateToProvider' },
	{ label: 'Pago proveedor desde', type: FilterType.DATE, key: 'paymentDateToProviderFrom' },
	{ label: 'Pago proveedor hasta', type: FilterType.DATE, key: 'paymentDateToProviderTo' },

	{ label: 'Costo', type: FilterType.NUMERIC, key: 'totalCostMainCurrency', operator: OperatorFilterEnum.EQUALS },
	{ label: 'Venta', type: FilterType.NUMERIC, key: 'totalSaleAmountMainCurrency', operator: OperatorFilterEnum.EQUALS },

	{ label: 'Notas voucher', type: FilterType.STRING, key: 'voucherNotes', operator: OperatorFilterEnum.CONTAINS },
	{ label: 'Notas internas', type: FilterType.STRING, key: 'internalNotes', operator: OperatorFilterEnum.CONTAINS },

	{ label: 'Inicio', type: FilterType.DATE, key: 'minStartDate' },
	{ label: 'Inicio desde', type: FilterType.DATE, key: 'minStartDateFrom' },
	{ label: 'Inicio hasta', type: FilterType.DATE, key: 'minStartDateTo' },

	{ label: 'Fin', type: FilterType.DATE, key: 'maxEndDate' },
	{ label: 'Fin desde', type: FilterType.DATE, key: 'maxEndDateFrom' },
	{ label: 'Fin hasta', type: FilterType.DATE, key: 'maxEndDateTo' },

	{ label: 'Activo', type: FilterType.BOOLEAN, key: 'enable' },

	{ label: 'Creado', type: FilterType.DATE, key: 'created' },
	{ label: 'Creado desde', type: FilterType.DATE, key: 'createdFrom' },
	{ label: 'Creado hasta', type: FilterType.DATE, key: 'createdTo' },
	{ label: 'Creado por', type: FilterType.STRING, key: 'createdBy', operator: OperatorFilterEnum.CONTAINS },

	{ label: 'Actualizado', type: FilterType.DATE, key: 'updated' },
	{ label: 'Actualizado por', type: FilterType.STRING, key: 'updatedBy', operator: OperatorFilterEnum.CONTAINS },
];

export const transformServiceValue = (key: string, value: unknown, row: IServiceListItem): any => {
	switch (key) {
		case 'paymentDateToProvider':
			return row.paymentDateToProvider ? formatDateToShowUser(row.paymentDateToProvider) : '-';

		case 'minStartDate':
			return row.minStartDate ? formatDateToShowUser(row.minStartDate) : '-';

		case 'maxEndDate':
			return row.maxEndDate ? formatDateToShowUser(row.maxEndDate) : '-';

		case 'created':
			return row.created ? formatDateTimeToShowUserFromSaleOrderApiValue(row.created) : '-';

		case 'updated':
			return row.updated ? formatDateTimeToShowUserFromSaleOrderApiValue(row.updated) : '-';

		case 'voucherNotes':
			return row.voucherNotes ?? '-';

		case 'internalNotes':
			return row.internalNotes ?? '-';

		case 'saleOrderIsBitrixDeal':
		case 'enable':
			return value ? 'Sí' : 'No';

		case 'totalCostMainCurrency':
		case 'totalSaleAmountMainCurrency':
			return value ?? '-';

		default:
			return value ?? '-';
	}
};
